import React from 'react';

export const LoadingSpinner = () => (
  <div className="flex items-center justify-center h-64">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);

export const ErrorMessage = ({ message, onRetry }) => (
  <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-4 mb-4">
    <h3 className="text-lg font-medium mb-2">Error Loading Data</h3>
    <p>{message}</p>
    <button 
      className="mt-3 bg-red-100 hover:bg-red-200 text-red-800 py-1 px-4 rounded transition-colors"
      onClick={onRetry}
    >
      Retry
    </button>
  </div>
);

export const NoDataMessage = ({ message = "No data is currently available." }) => (
  <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 rounded-lg p-4 mb-4">
    <h3 className="text-lg font-medium mb-2">No Data Available</h3>
    <p>{message}</p>
  </div>
);
